import React from "react";
import { Container, Typography } from "@mui/material";
import { getEnvironmentVariable } from "../../global/environmentVariables";

export default function VerifyInfo() {
  return (
    <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Why We Collect Your Information
      </Typography>
      <Typography variant="body1" paragraph>
        It is {getEnvironmentVariable("COMPANY_NAME")} duty and responsibility
        to accurately collect and report the information that is used in our
        payment processing under United States and other global banking rules
        and regulations. We are not do not store or keep this information and it
        is passed on to our payment processing agent via our secure site to
        comply with all applicable rules, laws and regulations around money
        transfers and handling. In order to comply with these standards we are
        often required to collect and pass on information such as:
      </Typography>
      <Typography variant="body1" paragraph>
        <ul>
          <li>The business type (individual or company)</li>
          <li>Full name of the individual or company representative</li>
          <li>Date of birth of the individual or company representative</li>
          <li>
            Address of the individual or business (not required for Australian
            and U.S. managed accounts at this stage)
          </li>
        </ul>
      </Typography>

      <Typography variant="body1" paragraph>
        In order to process some transactions we may require further information
        and may contact you as such. If you have any further questions or
        concerns please feel free to reach out to us at
        {getEnvironmentVariable("COMPANY_SUPPORT_EMAIL") ||
          "support@bestcoastpairings.com"}
      </Typography>
    </Container>
  );
}
